import { createContext } from "react";

export const LoadMoreContext = createContext();
export const AnimateContext = createContext();